import { render, staticRenderFns } from "./PurchaseWorkflowForm.vue?vue&type=template&id=66fd8147&scoped=true&lang=html&"
import script from "./PurchaseWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd8147",
  null
  
)

export default component.exports